
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 6H8.5A1.48 1.48 0 017 4.5V1H3c-.563 0-1 .469-1 1v12c0 .563.438 1 1 1h5c0 .375.094.719.25 1H3c-1.125 0-2-.875-2-2V2c0-1.094.875-2 2-2h4.875c.375 0 .781.188 1.063.469l3.593 3.594c.281.28.469.687.469 1.062V6zM8.5 5h3.469c-.031-.063-.063-.156-.125-.219L8.219 1.156c-.063-.062-.156-.093-.219-.125V4.5c0 .281.219.5.5.5zm4 3A1.5 1.5 0 0011 9.5V11h3V9.5c0-.813-.688-1.5-1.5-1.5zM10 9.5C10 8.125 11.094 7 12.5 7 13.875 7 15 8.125 15 9.5V11c.531 0 1 .469 1 1v3c0 .563-.469 1-1 1h-5c-.563 0-1-.438-1-1v-3c0-.531.438-1 1-1V9.5zm0 2.5v3h5v-3h-5z","fill":"#000"}})])
          )
        }
      }
    